import { hasValue } from 'src/packages/utils/has-value';

import type { TRestrictionsRule } from '../mappers';
import type { TControlView } from 'src/services/directory-service/types';

export const handleRestrictionsRule = (
  record: Record<string, unknown>,
  controlView: TControlView,
  rule: TRestrictionsRule,
  value: unknown,
): { value: unknown; validation: string[] } | null => {
  if (controlView.control === 'Field' && controlView.type === 'String') {
    let editedValue = value;

    if (
      hasValue(rule.ruleView.maxLength) &&
      typeof editedValue === 'string' &&
      editedValue.length > rule.ruleView.maxLength
    ) {
      editedValue = editedValue.slice(0, rule.ruleView.maxLength);
    }

    return { value: editedValue, validation: [] };
  }

  // TODO: здесь должна быть обработка min/max правил для числовых контролов

  return null;
};
